export const sportOptions = [
{value:'7560885c-cb87-4912-bc08-e5a3bc51713e',label:'Basketball'},
{value:'8c0a86f7-0c09-4e17-bc04-b66cdd8cf0b7',label:'Football'},
{value:'7bd017e1-c44d-41a9-8f7a-e5844acb965a',label:'Walking'},
{value:'123759c5-3fec-4cb5-9b47-0eb95d9b7f69',label:'Running'},
{value:'b0f2de67-c29a-4ee0-808b-e5996ad47d54',label:'Tennis'},
{value:'ad195e98-ea82-4a9c-a561-95883999b59c',label:'Volleyball'},
{value:'668aea4a-2698-4468-8994-eb51d6d15673',label:'Badminton'},
{value:'0b3dc824-e011-404a-96e8-4d28253550e5',label:'Table Tennis'},
{value:'dfb72e05-9808-4055-a295-18846a96ce82',label:'Cricket'},
{value:'d7d18c8f-31ec-4123-bce3-557aecf9fd26',label:'Baseball'},
{value:'887e3691-b444-4c29-879c-ca7dbc7a735e',label:'Cycling'},
{value:'f416845a-0be1-4fc0-bd52-49cfac1d76aa',label:'Swimming'},
{value:'ee6ce7b4-9678-4fb3-a5b6-9c05afd08e60',label:'Hiking'},
{value:'71b5b9b7-9201-49ae-9754-d0086eea41d6',label:'Skating'},
{value:'605051d1-8d8b-4bc0-82a2-026c7e8d0f52',label:'Rugby'},
{value:'02f1fc2e-7a63-47c1-aecf-0a0aa82fc799',label:'Handball'},
{value:'024759b1-fa00-4b9f-84a5-32ed94142d95',label:'Padel'},
{value:'dfb797b8-a4be-4e23-9abc-5b55688d1e51',label:'Pickleball'},
{value:'b5fd3e08-88cf-483c-bbe4-38de989c7e2c',label:'Golf'},
{value:'75c16902-ec28-4d5b-bec1-0ed56da2b5cc',label:'Squash'},
{value:'3a7f3f0b-82ba-464e-8762-ec98b1fa46f1',label:'Karate'},
{value:'1175228f-4e35-4751-a6fe-518670e91518',label:'Judo'},
{value:'16323135-141e-4e7d-b512-43659e99739b',label:'Boxing'},
{value:'d8ca49b7-e83b-42cd-ad74-2db0ee5291f8',label:'MMA'},
{value:'6e26735b-90d7-476b-be1b-4f8292ab742c',label:'Wrestling'},
{value:'7ed9aff6-5cc1-4209-89e0-068583060399',label:'Esports'},
{value:'8d89ec21-09ca-4483-8505-21c05f265578',label:'Archery'},
{value:'9984bc55-e446-44b9-a492-8a79beee2fce',label:'Fencing'},
{value:'808e4b73-33c6-44d3-baef-ef04651970f6',label:'Rowing'},
{value:'eee01361-0017-4272-8ff1-7b853deb25ed',label:'Kayaking'},
{value:'340166ce-4fa6-406a-8af7-ed36db54da44',label:'Surfing'},
{value:'f30bf95a-923d-49f2-9d1d-98574c2d89b0',label:'Sailing'},
{value:'d670502a-66b0-46c5-b820-32ba82f46eb4',label:'Snowboarding'},
{value:'f7bb9510-f811-4417-8e47-a5ec9362bf5e',label:'Skiing'},
{value:'f8a33e20-14b7-4834-8fdd-5c383dbafe25',label:'Ice Hockey'},
{value:'c8ecd0c4-7276-4661-89a8-9c5791570d66',label:'Field Hockey'},
{value:'508434dd-da10-41d6-bb76-2594fc3c3b6b',label:'Dodgeball'},
{value:'d37e3d29-9dd8-44ba-83f8-59cde4a360b2',label:'Ultimate Frisbee'},
{value:'402bba01-22ba-4ac6-b258-eb91e1cf510e',label:'Lacrosse'},
{value:'c1bdbd5b-d50e-4267-8896-8d341abbba33',label:'Climbing'},
{value:'f8f048bc-c198-40d6-a958-14425ef4d63b',label:'Parkour'},
{value:'2516806d-98d9-4d77-bacb-3e48acd13467',label:'Yoga'},
{value:'ecd5d513-38a1-4510-9132-4aa2a45fccd6',label:'Pilates'},
{value:'44de2241-8b42-4378-bfdb-4a133b752d40',label:'Zumba'},
{value:'a438e37b-fa8d-4732-ab19-85075d05b252',label:'CrossFit'},
{value:'a416d573-c498-4c05-905a-000a1cbb9ff0',label:'Dancing'},
{value:'2bd38cb0-5d9d-407b-815d-6a2fc6fb008a',label:'Billiards'},
{value:'83a30000-bf67-493d-91ad-3874866b0362',label:'Bowling'},
{value:'81c5e1dc-6839-43b1-bc2d-eda9ee2342ad',label:'Horse Riding'},
{value:'8b382941-7604-4364-9fd0-216cbe539f61',label:'Skateboarding'},
{value:'5ce70a85-1278-4e82-9d44-01abee4cf59d',label:'Darts'},
{value:'97e9ad5d-8d54-4d6a-a1a1-3859e0787a29',label:'Other'}

];

export const createSportOptions = (t: any, originalSportOptions: any[]) => 
    originalSportOptions.map(option => ({
        ...option,
        label: t(`sports.${option.label.toLowerCase()}`) || option.label
    }));